import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { messages } from '../../funciones/mensajes';
import { FiltersM } from '../../../components/models';

@Component({
  selector: 'app-reserva-cartera',
  templateUrl: './reserva-cartera.component.html',
  styleUrl: './reserva-cartera.component.css'
})
export class ReservaCarteraComponent {
  public Filters = FiltersM;
  public periodos = [];
  public periodoSeleccionado;
  public dataResumen = [];
  public dataIndice = [];
  public dataTabla = [];
  public perspectivas = [
    {id: 1,nombre: 'General'},
    {id: 2,nombre: 'Saldo pequeños deudores comerciales'},
    {id: 3,nombre: 'Saldo microcredito'},
    {id: 4,nombre: 'Saldo agropecuario'},
    {id: 5,nombre: 'Saldo consumo'},
    {id: 6,nombre: 'Saldo vivienda'},
  ];
  public perspectivaSelec = this.perspectivas[0];

  //variables personalizacion
  public miles = ',';
  public decimal = '.';



  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private exportExcel: ExcelService,
  ) {
    this.initPeriodos();
  }

  public async initPeriodos (){
    try{
      this.periodos = [{
        anio: 2025,
        series: [
          {
            "mes": "ene",
            "check": false,
            "an": 2025,
            "anio": "25",
            "periodo": "ene 25",
            "visible": true,
            "utilizable": true
          },
          {
            "mes": "feb",
            "check": false,
            "id": 492,
            "an": 2025,
            "anio": "25",
            "periodo": "feb 25",
            "visible": true,
            "utilizable": true
          },
          {
            "mes": "mar",
            "check": false,
            "id": 579,
            "an": 2025,
            "anio": "25",
            "periodo": "mar 25",
            "visible": true,
            "utilizable": true
          },
          {
            "mes": "abr",
            "check": false,
            "id": 580,
            "an": 2025,
            "anio": "25",
            "periodo": "abr 25",
            "visible": true,
            "utilizable": true
          },
          {
            "mes": "may",
            "check": false,
            "id": 581,
            "an": 2025,
            "anio": "25",
            "periodo": "may 25",
            "visible": true,
            "utilizable": true
          },
          {
            "mes": "jun",
            "check": false,
            "id": 582,
            "an": 2025,
            "anio": "25",
            "periodo": "jun 25",
            "visible": true,
            "utilizable": true
          },
          {
            "mes": "jul",
            "check": false,
            "id": 583,
            "an": 2025,
            "anio": "25",
            "periodo": "jul 25",
            "visible": true,
            "utilizable": true
          },
          {
            "mes": "ago",
            "check": true,
            "id": 584,
            "an": 2025,
            "anio": "25",
            "periodo": "ago 25",
            "visible": true,
            "utilizable": true
          }
        ],
        utilizable: true,
        visible: true
      }];
      this.periodoSeleccionado = this.periodos[0].series.find(i => i.check);
      this.getData();
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }
  }
  public cambioPeriodo(per){
    for (const an of this.periodos) {
      for (const mes of an.series) {
        if (mes.periodo === per.periodo) {
          mes.check = true;
          this.periodoSeleccionado = per;
        } else {
          mes.check = false;
        }
      }
    }
    this.getData();
  }
  public getData(){
    this.dataResumen = [
      {descripcion: 'Reserva Requerida Cifras al 31 de Octubre de 2025', rcapital:  113818710, rIntereses:  24244387, capInte:  138063097},
      {descripcion: 'Reserva Registrada Cifras al 31 de Octubre de 2025', rcapital:   143326920, rIntereses:   2598972, capInte:   145925892},
      {descripcion: 'Suficiencia de Reserva', rcapital:    29508210, rIntereses:   0, capInte:    7862795},
      {descripcion: 'Insuficiencia de Reserva', rcapital:   0, rIntereses:   -21645415, capInte:   0},
      {descripcion: 'Indicador de Reserva', rcapital:   125.9, rIntereses:   10.7, capInte:   105.7},
      {descripcion: 'Total Suficiencia de Provision de Cartera Capital e Intereses ', rcapital:    7862794.56},
      {descripcion: 'Total Insuficiencia de Provision de Cartera Capital e Interes', rcapital:   0},
    ];

    this.dataIndice = [
      {descripcion: 'Saldo cartera', dato: 5061095381.13},
      {descripcion: 'Creditos en Mora mayor a noventa > (90) dias', dato: 0},
      {descripcion: 'Indice de morosidad', dato: 0}
    ];
    this.getDataPerspectiva();
  }
  public getDataPerspectiva(){
    this.dataTabla = [];
    if(this.perspectivaSelec.id == 1){
      this.dataTabla = [
        {categoria: 'I', nombre: 'Créditos Bueno',dMora: 'Hasta 90 días', nPrestamos: 31186, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'I', nombre: 'Créditos Buenos: Tarjetas de Crédito',dMora: 'Hasta 90 días', nPrestamos: 6, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'II', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 208, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'III', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 0, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'IV', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 0, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'V', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 0, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'II', nombre: 'Créditos Especialmente Mencionados (Automaticos)', dMora: 'De 91 a 210 días', nPrestamos: 0, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'II', nombre: 'Créditos Especialmente Mencionados', dMora: 'De 91 a 150 días', nPrestamos: 26, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'II', nombre: 'Créditos Especialmente Mencionados', dMora: 'De 91 a 210 días', nPrestamos: 529, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'III', nombre: 'Créditos Bajo Norma (VIVIENDA)', dMora: 'De 151 a 210 días', nPrestamos: 8, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'III', nombre: 'Créditos Bajo Norma', dMora: 'De 211 a 360 días', nPrestamos: 0, sCapital: 380, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'IV', nombre: 'Créditos de Dudosa Recuperación (VIVIENDA)', dMora: 'De 211 a 360 días', nPrestamos: 5, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'IV', nombre: 'Créditos de Dudosa Recuperación', dMora: 'Más de 360 días', nPrestamos: 212, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'V', nombre: 'Créditos de Pérdida', dMora: 'Más de 450 días', nPrestamos: 3627, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'V', nombre: 'Créditos de Pérdida  (VIVIENDA)', dMora: 'Más de 720 días', nPrestamos: 0, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
      ]
    }else{
      this.dataTabla = [
        {categoria: 'I', nombre: 'Créditos Bueno',dMora: 'Hasta 90 días', nPrestamos: 898, provisiones: 0, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'II', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 4, provisiones: 5, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'III', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 0, provisiones: 25, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'IV', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 0, provisiones: 70, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'V', nombre: 'Créditos Especialmente Mencionados (Readecuado y CUPD sin Mora)', dMora: 'Hasta 90 días', nPrestamos: 0, provisiones: 100, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#72d54a'},
        {categoria: 'II', nombre: 'Créditos Especialmente Mencionados', dMora: 'De 91 a 210 días', nPrestamos: 29, provisiones: 5, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'III', nombre: 'Créditos Bajo Norma', dMora: 'De 211 a 360 días', nPrestamos: 25, provisiones: 25, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'IV', nombre: 'Créditos de Dudosa Recuperación', dMora: 'De 361 a 450 días', nPrestamos: 5, provisiones: 70, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
        {categoria: 'V', nombre: 'Créditos de Pérdida', dMora: 'Más de 450 días', nPrestamos: 152, provisiones: 100, sCapital: 0, sDesprotegido: 0, sInteres: 0, consolidado: 0, rCapital: 0, rInteres: 0, color:'#ff495c'},
      ]
    }
  }
  public cambiarPerspectiva(pers){
    this.perspectivaSelec = pers;
    this.getDataPerspectiva();
  }

}
